function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import cn from 'classnames';
import T from 'prop-types';
import React, { forwardRef, useEffect, useState } from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { useEvent } from 'react-use';
import { TOOLTIP } from '../../pages/constants';
import { KEY } from '../../utilities/events';
import { isWidthTruncated } from '../../utilities/events/validate';
import Control from '../form/Control';
var Cell = function(props, ref) {
    var className = props.className, children = props.children, id = props.id, _props_initialValidateEnabled = props.initialValidateEnabled, initialValidateEnabled = _props_initialValidateEnabled === void 0 ? false : _props_initialValidateEnabled, isFailed = props.isFailed, _props_isOutsideClickEnabled = props.isOutsideClickEnabled, isOutsideClickEnabled = _props_isOutsideClickEnabled === void 0 ? true : _props_isOutsideClickEnabled, isSuccessful = props.isSuccessful, onSubmit = props.onSubmit, validationSchema = props.validationSchema, value = props.value, maxLength = props.maxLength, colSpan = props.colSpan, rest = _object_without_properties(props, [
        "className",
        "children",
        "id",
        "initialValidateEnabled",
        "isFailed",
        "isOutsideClickEnabled",
        "isSuccessful",
        "onSubmit",
        "validationSchema",
        "value",
        "maxLength",
        "colSpan"
    ]);
    var _useState = _sliced_to_array(useState(value), 2), cellValue = _useState[0], setCellValue = _useState[1];
    var _useState1 = _sliced_to_array(useState(true), 2), isCellValueValid = _useState1[0], setIsCellValueValid = _useState1[1];
    var _useState2 = _sliced_to_array(useState(initialValidateEnabled), 2), isValidateEnabled = _useState2[0], setIsValidateEnabled = _useState2[1];
    var _useState3 = _sliced_to_array(useState(false), 2), isTooltipVisible = _useState3[0], setIsTooltipVisible = _useState3[1];
    var _useState4 = _sliced_to_array(useState(false), 2), isCellTruncated = _useState4[0], setIsCellTruncated = _useState4[1];
    var _useState5 = _sliced_to_array(useState(''), 2), invalidMsg = _useState5[0], setInvalidMsg = _useState5[1];
    useEffect(function() {
        return setCellValue(value);
    }, [
        value
    ]);
    var onChange = function(e) {
        return setCellValue(e.target.value);
    };
    var handleKeyPress = function(evt) {
        switch(evt.key){
            case KEY.ENTER:
                {
                    if (isCellValueValid) {
                        if (cellValue.trim() !== value) {
                            onSubmit(cellValue);
                        }
                        evt.target.blur();
                    }
                }
                break;
            case KEY.ESC:
                {
                    setCellValue(value);
                    evt.target.blur();
                }
                break;
        }
    };
    var handleMouseEnter = function(evt) {
        if (isWidthTruncated(evt)) {
            setIsCellTruncated(true);
        }
    };
    var handleToggle = function(isVisible) {
        return isCellTruncated && setIsTooltipVisible(isVisible);
    };
    if (isOutsideClickEnabled) {
        useEvent('click', function() {
            if (cellValue.trim() !== value && isCellValueValid) {
                setTimeout(function() {
                    return onSubmit(cellValue);
                }, 300);
            } else {
                setCellValue(value);
            }
        });
    }
    useEffect(function() {
        if (isValidateEnabled) {
            try {
                var isValid = validationSchema.trim().validateSync(cellValue);
                setIsCellValueValid(isValid);
                setInvalidMsg('');
            } catch (error) {
                setIsCellValueValid(false);
                setInvalidMsg(error.message);
            }
        } else {
            setIsValidateEnabled(true);
        }
    }, [
        cellValue
    ]);
    return /*#__PURE__*/ React.createElement("td", _object_spread({
        className: cn('Cell', className),
        ref: ref
    }, colSpan && {
        colSpan: colSpan
    }), /*#__PURE__*/ React.createElement("div", {
        className: "cellContainer"
    }, /*#__PURE__*/ React.createElement(OverlayTrigger, {
        show: isTooltipVisible,
        onToggle: handleToggle,
        placement: "top",
        delay: {
            show: TOOLTIP.SHOW_DELAY,
            hide: TOOLTIP.HIDE_DELAY
        },
        overlay: /*#__PURE__*/ React.createElement(Tooltip, {
            id: "cell-".concat(id)
        }, value)
    }, /*#__PURE__*/ React.createElement(Control, _object_spread({
        maxLength: maxLength ? maxLength + 1 : undefined,
        onMouseEnter: handleMouseEnter,
        isFailed: isFailed || !isCellValueValid,
        isSuccessful: isSuccessful,
        onKeyDown: handleKeyPress,
        onChange: onChange,
        value: cellValue,
        validationError: invalidMsg
    }, rest))), children));
};
Cell.propTypes = {
    className: T.string,
    children: T.node,
    id: T.number,
    initialValidateEnabled: T.bool,
    isFailed: T.bool,
    isOutsideClickEnabled: T.bool,
    isSuccessful: T.bool,
    maxLength: T.number,
    onSubmit: T.func,
    validationSchema: T.shape(),
    value: T.string,
    colSpan: T.number
};
export default /*#__PURE__*/ forwardRef(Cell);
